import { createAction, props } from '@ngrx/store';
import { Campaign } from '../../models/campaign.model';

export const setCampaign = createAction(
    '[Campaign] Update Campaign',
    props<{ selectedCampaign: Campaign }>()
);
